import React, { useEffect, useState } from "react";
import NotFound from "../../components/Common/NotFound/notFound";
import axios from "axios";
import { clearLoginSession } from "./../../services/ApiService";
import PropTypes from 'prop-types';

import APIService from "../../services/apiAxiosService";
import useHttp from "../../hooks/useHttp";
function ComponentWrapper(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [userHasAccess, setUserHasAccess] = useState(false);
  const { sendRequest: clearLoginSession } = useHttp();
  const getIfUserHasAccess = () => {
    const roleId = sessionStorage.getItem("roleId");
    const userID = sessionStorage.getItem("userId");
    const orgId = sessionStorage.getItem("orgId");
    // if (roleId && roleId != axios.defaults.headers.common["roleid"]) {
    //   clearLoginSession(APIService.clearLoginSession({ userID: userID }));
    //   sessionStorage.removeItem("jwtToken");
    //   window.location.href = process.env.REACT_APP_FRONTEND_URL;
    // } else if (userID && userID != axios.defaults.headers.common["userid"]) {
    //   clearLoginSession(APIService.clearLoginSession({ userID: userID }))
    //   sessionStorage.removeItem("jwtToken");
    //   window.location.href = process.env.REACT_APP_FRONTEND_URL;
    // }
    //  else if (orgId && orgId != axios.defaults.headers.common["orgid"]) {
    //   clearLoginSession({ userID: userID });
    //   sessionStorage.removeItem("jwtToken");
    //   window.location.href = process.env.REACT_APP_FRONTEND_URL;
    // } 
    // else {
      const { path } = { ...props };
      const roleToPath = [
        { path: "/analyst", roles: ["3"] },
        { path: "/workProgram", roles: ["3"] },
        { path: "/viewRisk", roles: ["3"] },
        { path: "/issueManagement", roles: ["3"] },
        { path: "/dashboard", roles: ["1", "2", "3", "4", "5"] },
        { path: "/auditHistory", roles: ["1", "2", "3", "4", "5"] },
        { path: "/notifications", roles: ["1", "2", "3", "4", "5", "6"] },
        { path: "/thirdpartyRequestManagement", roles: ["1"] },
        { path: "/create-thirdpartyrequest", roles: ["1"] },
        { path: "/businessImpact", roles: ["1"] },
        { path: "/risk", roles: ["1"] },
        { path: "/manager", roles: ["2"] },
        { path: "/manager/risk_management", roles: ["2"] },
        { path: "/analystIssues", roles: ["3"] },
        { path: "/analystRisks", roles: ["3"] },
        { path: "/admin", roles: ["6"] },
        { path: "/masterRepository", roles: ["6"] },
        { path: "/users", roles: ["6"] },
        { path: "/settings", roles: ["6"] },
        { path: "/vendor", roles: ["5"] },
        { path: "/initiateAssessment", roles: ["4"] },
        { path: "/onsiteAssessment", roles: ["4"] },
        { path: "/assessorWorkProgram", roles: ["4"] },
        { path: "/riskManagement", roles: ["4"] },
        { path: "/assessor/issue_management", roles: ["4"] },
        { path: "/vendor/issue_management", roles: ["5"] },
      ];
      setIsLoading(true);
      // Note: TODO send role id and path to API and get if user has access to this screen or not
      let didUserHasAccess = false;
      roleToPath.forEach((pathRole) => {
        if (pathRole.path === path) {
          if (pathRole.roles.includes(roleId)) {
            didUserHasAccess = true;
          }
        }
      });
      setIsLoading(false);
      setUserHasAccess(didUserHasAccess);
    // }
  };
  useEffect(() => {
    getIfUserHasAccess();
  });

  const displayLoader = () => {
    if (isLoading) {
      return (
        <div className="row" id="preloader">
          <div className="col-12 col-lg-12 mt-3 text-center">
            <div className="a-loading a-primary a-m-10">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    }
  };

  const displayComponent = () => {
    if (userHasAccess) {
      return props.children;
    } else {
      return <NotFound />;
    }
  };

  return (
    <div>
      {displayLoader()}
      {displayComponent()}
    </div>
  );
}
ComponentWrapper.propTypes = {
  children:PropTypes.any,

}


export default ComponentWrapper;
